<div class="border border-neutral-200 bg-white rounded-xl pb-4 px-4">
  @for (item of items; track item.key) {
    <div class="flex justify-between items-center border-b border-b-neutral-200 py-4">
      <div class="flex gap-x-4 items-center">
        <button (click)="removeOption.emit($index)">
          <mat-icon fontSet="material-icons-outlined" ctrHotelColor> delete </mat-icon>
        </button>
        <mat-slide-toggle
          [checked]="item.selected"
          (change)="toggleOption(item.key, $event.checked)"
          [hideIcon]="true"
          ctrColorSlideToggle
        ></mat-slide-toggle>
        <ctr-custom-icon size="24px" [icon]="item.icon"></ctr-custom-icon>
        <p class="text-sm font-semibold">
          {{ item.label }}
        </p>
      </div>
      <mat-icon class="cursor-pointer" (click)="itemSelected.emit(item)"> navigate_next </mat-icon>
    </div>
  }

  @if (!!addOptionText) {
    <div class="pt-4">
      <button (click)="addOption.emit()" ctrHotelColor class="text-sm font-semibold underline">
        {{ addOptionText }}
      </button>
    </div>
  }
</div>
